module.exports = __webpack_public_path__ + "static/media/0016.b7de98d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/Chassis_RAL/0016.png
// module id = 478
// module chunks = 0